import * as React from 'react';
import classnames from 'classnames';
import WorkingDaysSummary from 'common/entity/components/dayShift/WorkingDaysSummary';
import dayOfWeekSlotsSummaryFactory from './DayOfWeekSlotsSummaryFactory';

class RiderTimeSlotSummary extends React.PureComponent {
    render() {
        const { slots } = this.props;
        return <WorkingDaysSummary slots={slots} />;
    }
}

class RiderWorkingSlots extends React.PureComponent {
    render() {
        const { slots, theme } = this.props;
        return (
            <div className={theme.dayOfWeekWrap}>
                {slots.map(day => {
                    return (
                        <span
                            className={classnames(theme.dayOfWeek, {
                                [theme.noSlots]:
                                    !day.slot.start && !day.slot.end
                            })}
                            key={day.dayOfWeek}
                        >
                            {day.getShortCode()}
                        </span>
                    );
                })}
            </div>
        );
    }
}

const RiderSlots = dayOfWeekSlotsSummaryFactory({
    TimeSlotsSummary: RiderTimeSlotSummary,
    TableSlotSummary: RiderWorkingSlots
});

export default RiderSlots;
